// Compose a deep link that opens the right messaging app with the text ready
// to send. Cleaners choose SMS or WhatsApp; guests default to SMS.
export function messageLink(phone, body, platform = "sms") {
  const encoded = encodeURIComponent(body)
  if (platform === "whatsapp") {
    // wa.me wants the international number as digits only: no +, no spaces,
    // and an Australian 04xx number needs its 61 prefix.
    let digits = String(phone || "").replace(/[^\d]/g, "")
    if (/^0\d{9}$/.test(digits)) digits = `61${digits.slice(1)}`
    return `https://wa.me/${digits}?text=${encoded}`
  }
  // iOS wants `sms:<num>&body=`, Android wants `sms:<num>?body=`.
  const sep = /iPhone|iPad|Macintosh/.test(navigator.userAgent) ? "&" : "?"
  return `sms:${phone}${sep}body=${encoded}`
}

// WhatsApp opens in a new tab (wa.me is a web page); sms: links stay in place.
export function messageLinkProps(platform) {
  return platform === "whatsapp" ? { target: "_blank", rel: "noopener noreferrer" } : {}
}

export const PLATFORM_LABELS = { sms: "Messages", whatsapp: "WhatsApp" }

// Same {{placeholder}} substitution the server uses for guest templates.
export function renderTemplate(body, values) {
  return body.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => values[key] ?? "")
}

const day = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "short" })

// "11:00" -> "11:00am"
export function formatTime(hhmm) {
  if (!hhmm) return ""
  const [ h, m ] = hhmm.split(":").map(Number)
  const suffix = h >= 12 ? "pm" : "am"
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")}${suffix}`
}

// Values for the cleaner ask-message templates, built from a clean-shaped
// object + cleaner + property.
export function cleanTemplateValues({ cleanerName, propertyName, windowStartsOn, windowEndsOn, scheduledTime }) {
  return {
    cleaner_first_name: cleanerName ? cleanerName.split(" ")[0] : "",
    property_name: propertyName || "",
    clean_date: windowStartsOn ? day(windowStartsOn) : "",
    clean_time: formatTime(scheduledTime),
    window_start: windowStartsOn ? day(windowStartsOn) : "",
    window_end: windowEndsOn ? day(windowEndsOn) : windowStartsOn ? day(windowStartsOn) : "",
  }
}

export const CLEAN_KIND_TEMPLATE = {
  back_to_back: "clean_request_back_to_back",
  scheduled: "clean_request_scheduled",
  changeover: "clean_request_changeover",
  cleaner_chooses: "clean_request_cleaner_chooses",
}

// Pick the right cleaner template for a clean and render it.
export function cleanAskMessage(templates, propertyId, { kind, backToBack, ...rest }) {
  const templateKind = CLEAN_KIND_TEMPLATE[kind] || (backToBack ? "clean_request_back_to_back" : "clean_request_changeover")
  const template = (templates || []).find((t) => t.property_id === propertyId && t.kind === templateKind)
  if (!template) return ""
  return renderTemplate(template.body, cleanTemplateValues(rest))
}
